import { ref } from 'vue';

export const STATUS_PAGE_URL = 'https://cloudhumans.statuspage.io';

const POLL_INTERVAL_MS = 60000;

const indicator = ref('none');
const description = ref('');
const incidents = ref([]);

let pollTimer = null;

const fetchJson = url =>
  fetch(url)
    .then(response => response.json())
    .catch(() => null);

const fetchStatus = async () => {
  const statusBody = await fetchJson(`${STATUS_PAGE_URL}/api/v2/status.json`);
  if (!statusBody) return;

  const newIndicator = statusBody.status?.indicator || 'none';

  if (newIndicator === 'none') {
    indicator.value = 'none';
    description.value = statusBody.status?.description || '';
    incidents.value = [];
    return;
  }

  const incidentsBody = await fetchJson(
    `${STATUS_PAGE_URL}/api/v2/incidents/unresolved.json`
  );

  indicator.value = newIndicator;
  description.value = statusBody.status?.description || '';
  incidents.value = incidentsBody?.incidents || [];
};

const startPolling = () => {
  if (pollTimer) return;
  fetchStatus().catch(() => {});
  pollTimer = setInterval(fetchStatus, POLL_INTERVAL_MS);
};

const stopPolling = () => {
  if (!pollTimer) return;
  clearInterval(pollTimer);
  pollTimer = null;
};

export const useStatusPage = () => ({
  indicator,
  description,
  incidents,
  fetchStatus,
  startPolling,
  stopPolling,
});
